import axios from "axios";
import { ProjectFileApi, ProjectFileVerify } from ".";

export const fetchFileDetails = ({ id }) => {
  return axios
    .get(`${ProjectFileApi}${id}`)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const deleteFile = ({ id }) => {
  return axios
    .delete(`${ProjectFileApi}${id}`)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const verifyFileName = ({ params }) => {
  return axios
    .get(`${ProjectFileVerify}`, { params: { ...params } })
    .then((res) => {
      return res?.data;
    })
    .catch((error) => {
      throw error;
    });
};
